<script setup lang="ts">
const route = useRoute();
const localePath = useLocalePath();
const idOrder = route.params.id as string;
</script>

<template>
  <Navigation>
    <OrderDetails :order-id="idOrder" @on-order-list="navigateTo(localePath('/my-account/orders'))" />
    <ReturnRequestPanel :id-order="idOrder" :auto-open="route.query.action === 'refund'" />
  </Navigation>
</template>
